import {wasmPaths} from "../constants";
import DisableDevtool from 'disable-devtool';

export async function checkWebGPU() {// 检测是否支持webGPU
    // @ts-ignore
    if (!navigator.gpu) return false;// 没有gpu

    // @ts-ignore
    const adapter = await navigator.gpu.requestAdapter();
    return !!adapter
}
export const wasm = () => {// 判断浏览器是否支持WebAssembly
    // if (typeof WXWebAssembly !== 'undefined') return true;// 兼容微信小程序
    return typeof WebAssembly === 'object' && typeof WebAssembly.instantiate === 'function';
};
export const isSupportedSIMD = async () =>// 动态检测当前运行环境是否支持 SIMD
    WebAssembly.validate(
        new Uint8Array([
            0, 97, 115, 109,  // 魔数 "\0asm" 的十六进制表示（ASCII码）
            1, 0, 0, 0, // 版本号 1（小端序编码）
            1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0,
            253, 15, 253, 98,   // 关键指令部分：SIMD操作码（0xFD）及参数
            11,
        ])
    )
export const threads = () =>// 检测当前浏览器环境是否支持WebAssembly的线程（Threads）功能
    (async e => {
        try {
            // 检测跨域隔离状态
            // eslint-disable-next-line no-restricted-globals
            if (typeof self === 'undefined' || !self.crossOriginIsolated) return false;
            // 检测必要API
            if (typeof MessageChannel === 'undefined' || typeof SharedArrayBuffer === 'undefined') return false;

            return (
                typeof MessageChannel !== 'undefined' &&
                new MessageChannel().port1.postMessage(new SharedArrayBuffer(1)),// 验证SharedArrayBuffer可传输
                    WebAssembly.validate(e)
            )
            // eslint-disable-next-line @typescript-eslint/no-shadow
        } catch (e) {
            return !1
        }
    })(
        new Uint8Array([
            0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 5, 4, 1, 3, 1,
            1, 10, 11, 1, 9, 0, 65, 0, 254, 16, 2, 0, 26, 11,
        ])
    )
export const getBrowserCapabilities = async () => {// 获取当前使用的浏览器具备的能力
    return {
        webGPU: await checkWebGPU(),
        wasm: wasm(),
        simd: await isSupportedSIMD(),
        threads: await threads(),
    }
}

export const getTagSrc = async () => {
    const prefix = wasmPaths.url;
    const capabilities = await getBrowserCapabilities();
    if (capabilities.webGPU) {
        return `${prefix}ort.webgpu.min.js`
    }
    if (capabilities.wasm) {
        if (capabilities.simd || capabilities.threads) {
            return `${prefix}ort.wasm.min.js`
        }
        return `${prefix}ort.wasm-core.min.js`
    }
    return `${prefix}ort.min.js`;
}

export const loadingOnnxRuntime = async () => {
    const script = document.createElement('script');

    // 设置script标签的属性
    script.src = await getTagSrc(); // 要加载的脚本的URL

    // 将script标签添加到文档的head部分
    document.head.appendChild(script);
}


// 集成多功能防护库，支持检测F12、Ctrl+Shift+I、浏览器菜单打开、Eruda/VConsole调试工具等
export const disableDevtool = () => {
    DisableDevtool({
        md5: '7acb1fb5b9d807676767fc2c371d1fc5', // 加密绕过密钥 ‘algorithm_newbie’的md5码
        tkName: 'LXReaper',
        disableMenu: true,      // 禁用右键菜单
        detectors: [0, 1, 2, 3, 7], // 启用所有检测模式
        ondevtoolopen(type) {
            window.location.href = '/';
        }
    });
}
